/*----------------------------------
- FOOTER COLUMN
----------------------------------*/

import type { ComponentChildren } from 'preact';

/*----------------------------------
- TYPES
----------------------------------*/

type FooterColumnProps = {
    title: string;
    isOpen: boolean;
    onToggle: () => void;
    testId?: string;
    children: ComponentChildren;
};

/*----------------------------------
- COMPONENT
----------------------------------*/

/**
 * One footer link group. From `lg` up it is a plain titled column; on a phone the seven
 * columns would be a wall of links, so each becomes an accordion row with its links in
 * two columns. The links are hidden, never unmounted, so crawlers read all of them.
 */
export default function FooterColumn({ title, isOpen, onToggle, testId, children }: FooterColumnProps) {
    return (
        <div data-testid={testId} class="border-b border-[#e6e2da] lg:border-0">
            <button
                type="button"
                onClick={onToggle}
                aria-expanded={isOpen}
                class="flex w-full items-center justify-between gap-3 px-0.5 py-[15px] text-left text-[15px] font-semibold text-[#1b1d1e] lg:hidden"
            >
                {title}
                <span aria-hidden="true" class="w-[22px] flex-none text-center text-[22px] font-light leading-none text-[#a7a9a8]">
                    {isOpen ? '−' : '+'}
                </span>
            </button>
            <div class="hidden text-sm font-semibold text-slate-900 lg:block">{title}</div>
            <div
                class={`${isOpen ? 'grid' : 'hidden'} grid-cols-2 gap-x-4 gap-y-3 px-0.5 pb-[18px] pt-0.5 text-sm text-[#66696b] lg:mt-4 lg:block lg:space-y-3 lg:p-0 lg:text-slate-600`}
            >
                {children}
            </div>
        </div>
    );
}
